import { createIcon } from '@chakra-ui/react';

export const VidaMulherIcon = createIcon({
  displayName: 'VidaMulherIcon',
  viewBox: '0 0 107 101',
  path: [
    <path
      key="1"
      d="M31.2354 80.4248L46.5355 77.2809L48.1426 83.2003C48.6213 84.9648 49.742 86.3831 51.2167 87.0944C51.6403 87.2986 52.0881 87.454 52.5459 87.5583C52.9639 87.6515 53.3798 87.6959 53.7923 87.6959C56.5499 87.6959 59.0824 85.6773 59.7509 82.7386L60.9587 77.4152L75.0036 80.4248"
      stroke="#0066F3"
      strokeWidth="5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />,
    <path
      key="2"
      d="M53.4096 98L51.6999 97.0711C28.6223 84.5332 12.0845 66.1536 5.13215 45.318C4.58946 43.6978 4.10744 42.0698 3.70263 40.4873L3.66513 40.3197C3.22392 38.1768 3 35.9684 3 33.7556C3 16.7964 16.0654 3 32.1233 3C40.3431 3 48.0345 6.61112 53.5 12.859C58.9655 6.61112 66.6569 3 74.8756 3C90.9346 3 104 16.7964 104 33.7556C104 38.765 102.409 43.4758 100.92 47.4976C93.583 67.3965 77.3177 85.0037 55.1192 97.07L53.4096 98Z"
      stroke="#0066F3"
      strokeWidth="5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />,
    <path
      key="3"
      d="M70.6076 47.0173V57.4067C70.6076 66.9117 62.9559 74.6234 53.4952 74.6234C44.0478 74.6234 36.3828 66.9117 36.3828 57.4067V47.1416"
      stroke="#0066F3"
      strokeWidth="5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />,
    <path
      key="4"
      d="M74.3591 80.2919C76.0059 71.4594 78.2716 57.7063 78.2219 49.3721C78.1238 35.6312 67.153 24.4937 53.4953 24.4937C39.8376 24.4937 28.8415 35.6312 28.7797 49.3721C28.7301 57.3323 30.6747 71.2852 32.0613 80.2552"
      stroke="#0066F3"
      strokeWidth="5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />,
    <path
      key="5"
      d="M77.9426 55.5997C77.9426 55.5997 76.7359 45.2113 66.6178 47.0957C60.7453 48.1888 56.942 40.5604 57.7748 37.4997C57.7748 37.4997 51.5427 50.0554 36.237 47.1156C36.237 47.1156 27.4966 46.5097 28.9372 54.2857"
      stroke="#0066F3"
      strokeWidth="5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  ]
});
